// AllMeals.jsx - Updated with sorting functionality
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getAllMeals } from '../redux/actions/meals';
import { Loader, MealCategoryCard, MealsCard } from '../components/utils';


import { getAllCategorys } from '../redux/actions/category';

import { Section, Fotter, Header } from "../components/layout";
import { MealsCategoriesImage } from '../assets';
import { motion } from 'framer-motion';

import { media } from '../server';

import { FiChevronRight, FiGrid, FiList } from 'react-icons/fi';
import { BiRestaurant } from 'react-icons/bi';
import { useStateContext } from '../context/ContextProvider';

function AllMeals() {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const { currentDir } = useStateContext()
  const { isLoading, AllCategorys } = useSelector((state) => state.Categorys);

  useEffect(() => {
    // عرض جميع الفئات بدون pagination
    dispatch(getAllCategorys(1, 100));
  }, [dispatch]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', stiffness: 100, damping: 12 },
    },
  };



  return (

    <>
      <Header active={4} DropActive={4} />
    
      {/* HERO */}
      <section className="relative overflow-hidden">
    
        {/* Image */}
        <div className="relative h-[520px] lg:h-[720px]">
    
          <img
            src={MealsCategoriesImage}
            className="w-full h-full object-cover scale-105"
            alt="Meal Categories"
          />
    
          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30"></div>
    
          {/* Blur Effects */}
          <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-color-1/20 rounded-full blur-3xl"></div>
    
          <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-color-3/20 rounded-full blur-3xl"></div>
    
          {/* Content */}
          <div className="absolute inset-0 flex items-end">
    
            <div className="container pb-16 lg:pb-24">
    
              <motion.div
                initial={{ opacity: 0, y: 80 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="max-w-4xl"
              >
    
                {/* Badge */}
                <div className="inline-flex items-center gap-3 px-5 py-3 rounded-full bg-white/10 backdrop-blur-2xl border border-white/10 mb-6">
    
                  <BiRestaurant className="text-color-1 text-xl" />
    
                  <span className="text-white font-kufi">
                    {t("Authentic Yemeni Cuisine")}
                  </span>
    
                </div>
    
                {/* Title */}
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-kufi text-white leading-tight mb-6">
    
                  {t("Meal Categories")}
    
                </h1>
    
                {/* Description */}
                <p className="body-1 text-white/80 max-w-2xl leading-loose">
    
                  {t("Explore our diverse selection of authentic Yemeni dishes, each category crafted with traditional recipes and the finest ingredients.")}
    
                </p>
    
              </motion.div>
    
            </div>
    
          </div>
    
        </div>
    
      </section>
    
      {/* CONTENT */}
      <section className="relative py-20 md:py-28 overflow-hidden bg-back-secondary dark:bg-back-darkprimery">
    
        {/* Background */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-color-1/10 rounded-full blur-3xl"></div>
    
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-color-3/10 rounded-full blur-3xl"></div>
    
        <div className="container relative z-10">
    
          {
            isLoading ? (
    
              <div className="min-h-[50vh] flex items-center justify-center">
    
                <Loader />
    
              </div>
    
            ) : (
    
              <>
                {/* Top Bar */}
                <motion.div
                  initial={{ opacity: 0, y: -30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="mb-14 rounded-[2rem] border border-color-1/10 bg-white/70 dark:bg-back-darksecondary/80 backdrop-blur-2xl shadow-xl p-6"
                >
    
                  <div className="flex flex-col md:flex-row items-center justify-between gap-6">
    
                    {/* Left */}
                    <div className="flex items-center gap-4">
    
                      <div className="w-16 h-16 rounded-2xl bg-color-1/10 flex items-center justify-center">
    
                        <FiGrid className="text-color-1 text-2xl" />
    
                      </div>
    
                      <div>
    
                        <h2 className="font-kufi text-2xl text-tcolor-4 dark:text-tcolor-1">
    
                          {t("Food Categories")}
    
                        </h2>
    
                        <p className="text-gray-500 dark:text-gray-400">
    
                          {AllCategorys?.length || 0} {t("categories available")}
    
                        </p>
    
                      </div>
    
                    </div>
    
                    {/* Stats */}
                    <div className="flex flex-wrap items-center gap-4">
    
                      <div className="px-5 py-3 rounded-2xl bg-color-1/10 border border-color-1/10">
    
                        <span className="font-kufi text-color-1">
    
                          {t("Authentic Recipes")}
    
                        </span>
    
                      </div>
    
                      <div className="px-5 py-3 rounded-2xl bg-color-3/10 border border-color-3/10">
    
                        <span className="font-kufi text-color-3">
    
                          {t("Fresh Ingredients")}
    
                        </span>
    
                      </div>
    
                    </div>
    
                  </div>
    
                </motion.div>
    
                {/* Categories Grid */}
                <motion.div
                  variants={containerVariants}
                  initial="hidden"
                  animate="visible"
                  className="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8"
                >
    
                  {
                    AllCategorys?.map((category, index) => (
    
                      <motion.div
                        key={category._id || index}
                        variants={itemVariants}
                      >
    
                        <MealCategoryCard
                          category={category}
                          index={index}
                        />
    
                      </motion.div>
    
                    ))
                  }
    
                </motion.div>
    
                {/* Bottom */}
                {
                  AllCategorys?.length > 0 && (
    
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.4 }}
                      className="mt-20 text-center"
                    >
    
                      <div className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white dark:bg-back-darksecondary border border-color-1/10 shadow-xl">
    
                        <BiRestaurant className="text-color-1 text-xl" />
    
                        <span className="font-kufi text-gray-600 dark:text-gray-300">
    
                          {t("Showing")} {AllCategorys.length} {t("categories")}
    
                        </span>
    
                      </div>
    
                    </motion.div>
    
                  )
                }
              </>
            )
          }
    
        </div>
    
      </section>
    
      <Fotter />
    </>

    
  );
}

export default AllMeals;